import React from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import userStore from '@stores/userStore';

export default function NoAuthLayout() {
  const { accessToken, myInfo } = userStore();
  return (
    <>
      {accessToken && myInfo ? (
        <Navigate to="/home" replace="true" />
      ) : (
        <Outlet />
      )}
    </>
  );
}
